export const viewChangeDeliveryDateQuickSelect = () => ({
  type: `View Change Delivery Date quick select page`,
});
